<template>
    <div class="form-group__wrapper">
        <label :for="slug" class="form-group__label" :class="{ disabled: isDisabled, isSmall: isSmallLabel }">
            {{ label }}:
            <div v-if="description" class="form-group__tooltip">
                <IconTooltip :tooltipMessage="description" :isHtml="true"></IconTooltip>
            </div>
        </label>
        <VueMultiselect
            v-model="selectedValue"
            :closeOnSelect="true"
            maxHeight="85"
            :options="filterValues"
            label="title"
            track-by="title"
            :searchable="false"
            :multiple="false"
            openDirection="bottom"
            :showPointer="false"
            @select="onSelectChange"
            @remove="onSelectChange"
        ></VueMultiselect>
    </div>
</template>

<script lang="ts">
import IconTooltip from 'Vue/components/lockDesigner/components/shared/IconTooltip.vue';
import VueMultiselect from 'vue-multiselect';

export default {
    name: 'SingleSelect',
    components: {
        VueMultiselect,
        IconTooltip,
    },
    props: {
        slug: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        hasInfoButton: {
            type: Boolean,
            default: false,
        },
        filterValues: {
            type: Array,
            required: true,
        },
        isSmallLabel: {
            type: Boolean,
            default: false,
        },
        showNumResults: {
            type: Boolean,
            default: false,
        },
        description: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            selectedValue: '', // Track the selected value
        };
    },
    watch: {
        filterValues: {
            handler: 'updateSelectedValue',
            deep: true,
        },
    },
    mounted() {
        // Set the initial selected value based on isSelected property
        this.updateSelectedValue();
    },

    methods: {
        onSelectChange() {
            const selected = this.selectedValue;
            let filterValuesCopy = [...this.filterValues];
            filterValuesCopy = filterValuesCopy.map((option) => {
                return { ...option, isSelected: !!selected && option.title === selected.title };
            });

            let newOptions = JSON.parse(JSON.stringify(filterValuesCopy));
            this.$emit('filterChange', newOptions);
        },
        onInfoButtonClick() {
            this.$emit('infoButtonClick');
        },
        updateSelectedValue() {
            // Set the selected value based on the isSelected property
            const selectedFilter = this.filterValues.find((filterItem) => filterItem.isSelected);
            this.selectedValue = selectedFilter ? selectedFilter : null;
        },
    },
};
</script>
